export async function registerAthlete(apiInstance, eventId, athleteData) {
  try {
    const response = await apiInstance.post(
      `/Athlete/register/
      ${eventId}`,
      athleteData,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function registerAthleteWithEventId(
  apiInstance,
  athleteData,
  eventId,
) {
  try {
    const response = await apiInstance.post(
      `/athlete/register/${eventId}`,
      athleteData,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function SearchAthleteByParams(apiInstance, query) {
  try {
    const response = await apiInstance.get(`/Athlete/search?q=${query}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function SearchAthletesPagedAsync(
  apiInstance,
  {
    q = "",
    page = 0,
    pageSize = 20,
    position,
    gradYear,
    highSchool,
    favoritesOnly = false,
    similar,
    athleteId,
  } = {},
) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));

  // position and gradYear accept either a single value or an array. Repeated
  // query params (?position=QB&position=RB) bind into a string[]/int[] on the server.
  const positionList = Array.isArray(position)
    ? position
    : position
      ? [position]
      : [];
  positionList.forEach((p) => params.append("position", String(p)));

  const gradYearList = Array.isArray(gradYear)
    ? gradYear
    : gradYear != null && gradYear !== ""
      ? [gradYear]
      : [];
  gradYearList.forEach((y) => params.append("gradYear", String(y)));

  if (highSchool) params.set("highSchool", highSchool);
  if (favoritesOnly) params.set("favoritesOnly", "true");
  if (similar) params.set("similar", similar);
  if (athleteId != null) params.set("athleteId", String(athleteId));

  try {
    const response = await apiInstance.get(
      `/Athlete/search-paged?${params.toString()}`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function ConfirmRegistration(apiInstance, eventId, userId) {
  try {
    const data = {
      eventId: eventId,
      userId: userId,
    };
    const response = await apiInstance.post(
      `/Athlete/confirm-registration`,
      data,
    );
    return response.data;
  } catch (err) {
    return err;
  }
}

//service for athele profile

export const getAthleteProfile = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(`/Athlete/profile/${userId}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getAthleteCompareData = async (
  apiInstance,
  userId,
  compareToUserId,
) => {
  try {
    const response = await apiInstance.get(
      `/Athlete/${userId}/compare/${compareToUserId}`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

// services for linking a ethlete
export const likeAthlete = async (apiInstance, status, userId) => {
  try {
    const response = await apiInstance.get(`/athlete/like/${status}/${userId}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getMeasurements = async (apiInstance, UserAthleteId) => {
  try {
    const response = await apiInstance.get(
      `/athlete/${UserAthleteId}/measurements`,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getAllTimeBestResults = async (apiInstance, UserId) => {
  try {
    const response = await apiInstance.get(`/Athlete/${UserId}/best-results`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const saveVideo = async (apiInstance, videoData) => {
  try {
    const response = await apiInstance.post("replace_url", videoData);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("An error occurred while saving the video");
  }
};

export const getVideo = async (apiInstance, videoId) => {
  try {
    const response = await apiInstance.get(`replace_url/${videoId}`);
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("An error occurred while saving the video");
  }
};

export const CreateOffer = async (apiInstance, objOffer) => {
  try {
    const response = await apiInstance.post(`/Athlete/Offers`, objOffer);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const CreateAccolade = async (apiInstance, objAccolade) => {
  try {
    const response = await apiInstance.post(`/Athlete/Accolades`, objAccolade);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};
export const getOffers = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(`/Athlete/${userId}/Offers`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getAccolades = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(`/Athlete/${userId}/Accolades`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getOffersAccolades = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(
      `/Athlete/${userId}/accolades-offers`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getAthleteCombines = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(`/athlete/${userId}/combines`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const deleteAccolade = async (apiInstance, accoladeId) => {
  try {
    const response = await apiInstance.delete(
      `/athlete/accolades/${accoladeId}`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const deleteOffer = async (apiInstance, offerId) => {
  try {
    const response = await apiInstance.delete(`/athlete/offers/${offerId}`);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const updateAthleteProfile = async (
  apiInstance,
  userId,
  profileData,
) => {
  try {
    const response = await apiInstance.put(
      `/athlete/profile/${userId}`,
      profileData,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating athlete profile:", error);
    throw error;
  }
};

export const getCoachesThatLikeAthlete = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(`/athlete/${userId}/coach-likes`);
    return response.data;
  } catch (error) {
    throw new Error("Error fetching coaches: " + error.message);
  }
};

export const sendReview = async (apiInstance, userId, data) => {
  try {
    const response = await apiInstance.post(`/athlete/${userId}/review`, data);
    return response;
  } catch (error) {
    throw new Error("Error fetching coaches: " + error.message);
  }
};

export const getReview = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(`/athlete/${userId}/review`);
    return response;
  } catch (error) {
    throw new Error("Error fetching coaches: " + error.message);
  }
};

export const toggleShareWithCoach = async (
  apiInstance,
  status,
  coachUserId,
) => {
  try {
    const response = await apiInstance.get(
      `/Athlete/share-with-coach/${status}/${coachUserId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error("Error updating share status: " + error.message);
  }
};

export const updateProfileIsPublic = async (apiInstance, toggle, userId) => {
  try {
    const response = await apiInstance.put(
      `/Athlete/profile/${userId}/public/${toggle}`,
    );
    return response.data;
  } catch (error) {
    throw new Error("Error updating share status: " + error.message);
  }
};

//servive for update biography info
export const updateUserBio = async (apiInstance, userId, bio) => {
  try {
    const response = await apiInstance.put(`/user/bio`, { userId, bio });
    return response.data;
  } catch (error) {
    throw new Error("Error updating bio: " + error.message);
  }
};

// SERVICES TO ADDITIONAL INFO
export const getAdditionalInfo = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(
      `/athlete/${userId}/additional-info`,
    );
    return response.data;
  } catch (error) {
    throw new Error("Error retrieving additional info: " + error.message);
  }
};

export const getPositionDrillsResults = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(
      `/athlete/${userId}/position-drills`,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const insertProfileVideoService = async (
  apiInstance,
  data,
  setUploadProgress,
) => {
  try {
    const response = await apiInstance.post(`/athlete/profile-video`, data, {
      timeout: 10 * 60 * 1000,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
        if (typeof setUploadProgress === "function") {
          setUploadProgress(percentCompleted);
        }
      },
    });
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const deleteProfileVideoService = async (
  apiInstance,
  profileVideoId,
) => {
  try {
    const response = await apiInstance.delete(
      `/athlete/${profileVideoId}/profile-video`,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};
export const getProfileVideoService = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(`/athlete/profile-videos/${userId}`);
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const updateUserContactInfo = async (
  apiInstance,
  userId,
  contactInfo,
) => {
  try {
    const response = await apiInstance.put(
      `/athlete/${userId}/additional-info`,
      contactInfo,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response.data.message || "Error updating contact info",
    );
  }
};

export const insertProfileVideoLinksService = async (apiInstance, data) => {
  try {
    const response = await apiInstance.post(
      `/athlete/profile-video-links`,
      data,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getProfileVideoLinksService = async (apiInstance) => {
  try {
    const response = await apiInstance.get(`/athlete/profile-video-links`);
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const getExerciseHistoryService = async (
  apiInstance,
  userId,
  physicalTestName,
  stage,
) => {
  try {
    const response = await apiInstance.get(
      `/Athlete/${userId}/exercise-history`,
      {
        params: { physicalTestName, stage },
      },
    );
    return response.data;
  } catch (err) {
    throw err.response
      ? err.response.data
      : new Error("Error getting exercise history");
  }
};

export const getMeasurementHistory = async (apiInstance, userId, parameter) => {
  try {
    const response = await apiInstance.get(
      `/athlete/${userId}/measurement-history`,
      {
        params: { parameter },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching measurement history:", error);
    throw error;
  }
};

export const insertAthleteFileService = async (apiInstance, fileType, file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await apiInstance.post(
      `/FilesStorage/athlete-file`,
      formData,
      {
        headers: {
          accept: "text/plain",
          "Content-Type": "multipart/form-data",
        },
        params: {
          fileType: fileType,
        },
      },
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};

export const deleteAthleteFileService = async (apiInstance, model, id) => {
  if (!model || !id) {
    throw new Error("Model and ID are required to delete a file.");
  }

  try {
    const response = await apiInstance.delete(
      `/FilesStorage/File/${model}/${id}`,
      {
        headers: {
          accept: "text/plain",
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error.response ? error.response.data : error.message;
  }
};

export async function SearchFavouriteAthleteByParams(apiInstance, query) {
  try {
    const response = await apiInstance.get(
      `/Athlete/search?q=${query}&IsFavorite=true`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function SearchAthleteByAthleteId(apiInstance, query = "") {
  try {
    const qs = String(query || "").trim();

    const url = qs ? `/Athlete/search?${qs}` : `/Athlete/search`;

    const response = await apiInstance.get(url);
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export async function PostCandidateAthlete(apiInstance, candidateData) {
  try {
    const response = await apiInstance.post(
      `/public/candidate-athlete`,
      candidateData,
    );
    return response;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
}

export const getAthleteCombineHistory = async (apiInstance, userId) => {
  try {
    const response = await apiInstance.get(
      `/athlete/${userId}/combine-compare`,
    );
    return response.data;
  } catch (err) {
    throw err.response ? err.response.data : new Error("An error occurred");
  }
};
